import { ExtractPropTypes, PropType } from 'vue'

export const emptyProps = {
  image: String,
  imageSize: Number,
  description: String,
} as const

export type EmptyProps = Partial<ExtractPropTypes<typeof emptyProps>>

export const emptyEmits = {
  
}

export type EmptyEmits = typeof emptyEmits
